var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"dark":"","color":_vm.buttonColor},on:{"click":_vm.changeStatus}},[_vm._v(" "+_vm._s(_vm.$t(_vm.buttonText))+" "),_c('UserStatusIcon',{attrs:{"user-enabled":!_vm.user.enabled}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }